module.exports = __webpack_public_path__ + "img/drop-down-active.a2588eb0.svg";